<template>
  <div id="app">
    <el-container>
    <el-aside width="200px">
      <LeftMenuComponent v-if="route.path !== '/login'"></LeftMenuComponent>
    </el-aside>
    <el-main v-if="route.path !== '/login'">
      <div class="top-content-wrap">
        <el-button link type="primary" class="logout" @click="doLogout">退出登录</el-button>
      </div>
      <router-view class="main-page"></router-view>
    </el-main>
  </el-container>
    <router-view v-if="route.path == '/login'"></router-view>
  </div>
</template>

<script>
import { onMounted } from 'vue';
import LeftMenuComponent from './components/LeftMenu.vue'
import {  useRoute,useRouter } from 'vue-router'
import { logout } from '@/api/index'
import { ElMessage } from 'element-plus'
export default {
  name: 'App',
  components: {
    LeftMenuComponent
  },
  setup(){
    const route = useRoute()
    const router = useRouter()
    const doLogout =async()=>{
      const res = await logout()
      if(res.code ==200){
        localStorage.removeItem('userId')
        sessionStorage.removeItem('activeIndex')
        router.replace('/login')
      }else{
        ElMessage.error('退出登录失败')
      }
    }
    return {
      route,
      doLogout
    }
  }

}
</script>

<style lang="less" scoped>
#app {
  margin: 0;
  padding: 0;
  .el-main{
    padding: 0 !important;
  }
  .top-content-wrap{
    width: calc(100vw - 200px);
    height: 40px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    text-align: right;
    position: relative;
    .logout{
      margin-right: 30px;
      margin-top: 4px;
    }
    .user-name{
      font-size: 16px;
      color: #666;
      position: absolute;
      top: 10px;
      right: 120px;
    }
  }
  .main-page{
    width: calc(100vw - 200px);
    height: calc(100vh - 40px);
    overflow-y: scroll;
  }
}
</style>
